import React from "react";
import useNurses from "@hooks/useNurses";
import NurseAddContents from "./NurseAddContents";
import useAvailableMember from "@/hooks/useAvailbleMember";
import CustomModal from "@/components/modal/CustomModal";

interface NurseAddModalProps {
  onClose: () => void;
  selectedGroupId?: string | null;
}

const NurseAddModal: React.FC<NurseAddModalProps> = ({
  onClose,
  selectedGroupId,
}) => {
  const { isLoading: nurseLoading } = useNurses(selectedGroupId);
  const { isPending } = useAvailableMember();

  return (
    <CustomModal.Panel
      onClose={onClose}
      loadingMsg="근무자 정보를 불러오는 중입니다."
      isLoading={nurseLoading || isPending}
    >
      <NurseAddContents onClose={onClose} selectedGroupId={selectedGroupId!} />
    </CustomModal.Panel>
  );
};

export default NurseAddModal;
